import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router'
import { connect } from 'react-redux'
import pick from '../utilities/pick'
import getStartLocationForUser from '../utilities/getStartLocationForUser'

class PrivateRoute extends React.Component {
	constructor(props) {
		super(props)

		this.setDesiredLocation = this.setDesiredLocation.bind(this)
	}

	setDesiredLocation() {
		if (this.props.user && this.props.user.isAnonymous) {
			global.localStorage.setItem('desiredLocation', `${this.props.location.pathname}${this.props.location.search ? this.props.location.search : ''}`)
		}
	}

	render() {
		const { component, user, allowNotActivated, componentProps, ...rest } = this.props
		let Component = component
		return (
			<Route
				{...rest}
				render={
					(routerProps) => {
						if (!user || user.isLoading) {
							// wait for user to load
							return null
						}
						if (user.isAnonymous) {
							// anonymous is not allowed, login
							this.setDesiredLocation()
							return <Redirect to="/login" />
						}
						if (!user.isActivated) {
							if (!allowNotActivated) {
								// inactive is not allowed, onboarding
								this.setDesiredLocation()
								return <Redirect to={getStartLocationForUser(user)} />
							}
							// inactive is allowed...
							if (typeof allowNotActivated === 'function') {
								// via a different component
								Component = allowNotActivated
							}
						}
						return <Component {...{ ...routerProps, ...componentProps }} />
					}
				}
			/>
		)
	}
}

PrivateRoute.propTypes = {
	allowNotActivated: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
	user: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	component: PropTypes.func.isRequired,
	componentProps: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired,
		search: PropTypes.string
	}).isRequired
}

PrivateRoute.defaultProps = {
	allowNotActivated: false,
	user: undefined,
	componentProps: {}
}

export const testing = {
	PrivateRoute
}

export default connect(
	/* istanbul ignore next line */
	state => pick(state, ['user']),
	/* istanbul ignore next line */
	null
)(PrivateRoute)



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.jsx